<script setup lang="ts">
/**
 * @description UI-kit icon component — raw-SVG icon from Strapi IconHub in a sized container
 * @category UI / Icons
 */
// types
import type { AppIconStrapiProps } from '../types/interfaces'
// hooks
import { useAppIconStrapi } from '../composables/use-app-icon-strapi.hook'

defineOptions({
  name: 'AppIconStrapi',
})

const props = withDefaults(defineProps<AppIconStrapiProps>(), {
  size: 'big',
  color: undefined,
})

const { classList, refViewBox } = useAppIconStrapi({ props })
</script>

<template>
  <span
    v-if="icon.iconData"
    :class="classList"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      :viewBox="refViewBox"
      v-html="icon.iconData"
    />
  </span>
</template>

<style scoped lang="scss" src="../styles/_app-icon-strapi.scss" />
